import { Smile, Timer, Stethoscope, Zap, ShieldCheck, HeartHandshake } from 'lucide-react';

const benefits = [
  {
    title: 'Comfortable Care',
    desc: 'Modern technology helps us reduce pain, eliminate messy impressions, and create a stress-free experience.',
    icon: Smile,
  },
  {
    title: 'Faster Visits',
    desc: 'Our tools speed up procedures and reduce the number of visits you need.',
    icon: Timer,
  },
  {
    title: 'Smarter Diagnostics',
    desc: 'Digital imaging and AI help us detect problems earlier and more accurately.',
    icon: Stethoscope,
  },
  {
    title: 'Minimally Invasive',
    desc: 'Laser dentistry and no-drill techniques mean less discomfort and faster healing.',
    icon: Zap,
  },
  {
    title: 'Safe & Precise',
    desc: 'Digital workflows reduce contamination and improve treatment precision.',
    icon: ShieldCheck,
  },
  {
    title: 'Confidence in Care',
    desc: 'With visual tools like intraoral cameras, you\'ll feel informed and in control.',
    icon: HeartHandshake,
  },
];

export default function TechnologyBenefits() {
  return (
    <section className="bg-gradient-to-r from-teal-50 to-lime-50 py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="text-center max-w-4xl mx-auto space-y-6 mb-12">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-800">
          Benefits for You
        </h2>
        <p className="text-gray-600 text-lg">
          Our advanced dental technology is designed to make your care more comfortable, efficient, and effective.
        </p>
      </div>

      {/* Desktop Vertical Zigzag Timeline */}
      <div className="hidden md:block max-w-4xl mx-auto relative">
        {/* Vertical center line */}
        <div className="absolute left-1/2 top-0 bottom-0 w-1 bg-teal-200 z-0" />
        
        <div className="space-y-16">
          {benefits.map((item, i) => {
            const Icon = item.icon;
            const isEven = i % 2 === 0;
            
            return (
              <div key={i} className="relative">
                {/* Horizontal connector */}
                <div className={`absolute top-8 h-1 bg-teal-200 z-0 ${!isEven ? 'left-1/2' : 'right-1/2'}`} />
                
                {/* Content container with zigzag positioning */}
                <div className={`flex items-center ${isEven ? 'flex-row' : 'flex-row-reverse'}`}>
                  {/* Left/Right side (alternating) content */}
                  <div className={`w-1/2 ${isEven ? 'pr-16 text-right' : 'pl-16'}`}>
                    <h3 className="text-xl font-semibold text-teal-600 mb-2">{item.title}</h3>
                    <p className="text-gray-600">{item.desc}</p>
                  </div>
                  
                  {/* Center timeline element */}
                  <div className="relative">
                    {/* Icon circle */}
                    <div className={`${isEven ? 'bg-teal-500' : 'bg-lime-500'} text-white p-4 rounded-full shadow-lg z-10 relative`}>
                      <Icon className="w-6 h-6" />
                    </div>
                    
                    {/* Step number */}
                    {/* <div className="absolute top-0 right-0 -mt-1 -mr-1">
                      <span className="bg-white text-xs font-bold text-gray-500 w-5 h-5 rounded-full flex items-center justify-center border border-gray-200">
                        {i + 1}
                      </span>
                    </div> */}
                  </div>
                  
                  {/* Empty div for layout */}
                  <div className="w-1/2" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
      
      {/* Mobile Vertical Timeline */}
      <div className="md:hidden max-w-xs mx-auto">
        <div className="relative pl-12">
          {/* Vertical line */}
          <div className="absolute left-4 top-0 bottom-0 w-1 bg-teal-200 z-0" />
          
          <div className="space-y-10">
            {benefits.map((item, i) => {
              const Icon = item.icon;
              const isEven = i % 2 === 0;
              
              return (
                <div key={i} className="relative">
                  {/* Horizontal connector */}
                  <div className="absolute left-4 top-8 w-4 h-1 bg-teal-200 z-0" />
                  
                  {/* Icon */}
                  <div className={`absolute -left-14 ${isEven ? 'bg-teal-500' : 'bg-lime-500'} text-white p-3 rounded-full shadow-lg z-10`}>
                    <Icon className="w-5 h-5" />
                  </div>
                  
                  {/* Step Number */}
                  {/* <div className="absolute left-0 top-0 -mt-1 -ml-1">
                    <span className="bg-white text-xs font-bold text-gray-500 w-4 h-4 rounded-full flex items-center justify-center border border-gray-200">
                      {i + 1}
                    </span>
                  </div> */}
                  
                  {/* Content */}
                  <div className="ml-4">
                    <h3 className="text-lg font-semibold text-teal-600 mb-1">{item.title}</h3>
                    <p className="text-sm text-gray-600">{item.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}